export function loadMoreButton() {
  const loadMoreButtons = document.querySelectorAll('.load_more');
  loadMoreButtons.forEach(function(loadMoreButton) {
    const openText = loadMoreButton.textContent;

    loadMoreButton.addEventListener('click', loadMoreEvent.bind(loadMoreButton, openText));
  });
}

function loadMoreEvent(openText, e) {
  e.preventDefault();

  const panel = this.parentElement;
  const hideContent = panel.querySelector('.hideContent');

  if (hideContent.classList.contains('open')) {
    $(hideContent).slideUp();
    hideContent.classList.remove('open');
    this.textContent = openText;
  } else {
    $(hideContent).slideDown();
    hideContent.classList.add('open');
    this.textContent = I18n.t('js.load_more.close_more');
  }
}
